import { useState, type InputHTMLAttributes } from 'react';
import { formatMoedaSemSimbolo, parseMoeda } from '@fiodecobre/shared';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value' | 'type'> & {
  valor: number;
  onChangeValor: (n: number) => void;
  // casas decimais exibidas (default 2; preco de produto usa 4).
  casas?: number;
};

// Input monetario pt-BR. Mostra formatado, parseia ao perder foco.
export function MoneyInput({ valor, onChangeValor, casas = 2, ...rest }: Props) {
  const [editando, setEditando] = useState(false);
  const [textoLocal, setTextoLocal] = useState<string>('');

  const display = editando ? textoLocal : formatMoedaSemSimbolo(valor, casas);

  return (
    <input
      type="text"
      inputMode="decimal"
      value={display}
      data-componente="006"
      onFocus={(e) => {
        setEditando(true);
        setTextoLocal(formatMoedaSemSimbolo(valor, casas));
        e.currentTarget.select();
      }}
      onChange={(e) => setTextoLocal(e.currentTarget.value)}
      onBlur={() => {
        setEditando(false);
        onChangeValor(parseMoeda(textoLocal));
      }}
      {...rest}
    />
  );
}
